
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const LoginSignupButtons = () => {
  return (
    <div className="flex items-center space-x-2">
      <Link to="/auth">
        <Button variant="ghost" size="sm" className="px-4 py-1.5 text-sm font-medium text-gray-800 hover:bg-transparent hover:text-gray-800 transition-colors">
          Login
        </Button>
      </Link>
      <Link to="/auth?tab=signup">
        <Button size="sm" className="px-4 py-1.5 bg-black text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors">
          Sign up
        </Button>
      </Link>
    </div>
  );
};

export default LoginSignupButtons;
